/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";
export const protobufPackage = "portal";
export var MagicLinkAuthenticationErrorTypes;
(function (MagicLinkAuthenticationErrorTypes) {
    /** UNUSED - unused is because our REST helpers won't send 0 for some reason */
    MagicLinkAuthenticationErrorTypes["UNUSED"] = "UNUSED";
    MagicLinkAuthenticationErrorTypes["USER_NOT_FOUND"] = "USER_NOT_FOUND";
    MagicLinkAuthenticationErrorTypes["COMPANY_NOT_VALID"] = "COMPANY_NOT_VALID";
    MagicLinkAuthenticationErrorTypes["EMAIL_INVALID"] = "EMAIL_INVALID";
    MagicLinkAuthenticationErrorTypes["COMPANY_NOT_FOUND"] = "COMPANY_NOT_FOUND";
})(MagicLinkAuthenticationErrorTypes || (MagicLinkAuthenticationErrorTypes = {}));
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
